<style scoped>
.simple-size {
    color: #ccc;
    font-size: 12px;
    height: 20px;
    padding: 0;
    margin: 0;
}
</style>

<template>
<div>
    <Modal
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose">

        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
            <FormItem label="姓名:" prop="name">
                <Input type="text" v-model="formData.name"></Input>
            </FormItem>
            <FormItem label="手机:" prop="mobile">
                <Input type="text" v-model="formData.mobile" placeholder="手机即为登录帐号"></Input>
            </FormItem>
            <FormItem label="邮箱" prop="email">
                <Input type="text" v-model="formData.email" placeholder=""></Input>
            </FormItem>
            <FormItem label="密码:" prop="password">
                <Input type="password" v-model="formData.password"></Input>
            </FormItem>

            <FormItem label="部门：" prop="all_section">
                <Cascader :data="sectionData" v-model="formData.all_section" filterable></Cascader>
            </FormItem>
            <FormItem label="角色：" prop="role_id">
                <RadioGroup v-model="formData.role_id">

                    <Radio :label="item.id" v-for="(item, index) in roleList" :key="index">
                        <span>{{item.name}}</span>
                    </Radio>
                </RadioGroup>
            </FormItem>
            <FormItem label="状态：" prop="status">
                <RadioGroup v-model="formData.status">
                    <Radio label="1">
                        <span>在职</span>
                    </Radio>
                    <Radio label="2">
                        <span>离职</span>
                    </Radio>
                </RadioGroup>
            </FormItem>

            <FormItem label="职位：" prop="type">
                <RadioGroup v-model="formData.type">
                    <Radio label="1">
                        <span>运营</span>
                    </Radio>
                    <Radio label="2">
                        <span>销售</span>
                    </Radio>
                </RadioGroup>
            </FormItem>

            <FormItem>
                <Button :disabled="disabled" type="primary" @click="subData('formData')">确定</Button>
            </FormItem>
        </Form>

    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object
        },
        name: "Model3",
        data() {
            return {
                searchEmpUrl: this.config.urlArray.searchEmp,
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                sectionData: [],//部门数据
                roleList: [],//角色数据
                formData: {//表单数据
                    name: '',
                    mobile: '',
                    password: '',
                    status: '1',
                    email: '',
                    type: '1',
                    role_id: 0,
                    all_section:[],
                },
                ruleCustom: {//验证
                    name: [
                        {required: true, message: '姓名不能为空', trigger: 'blur' },
                    ],
                    mobile: [
                        {required: true, message: '手机不能为空', trigger: 'blur' },
                        { type: 'string', pattern: /^1\d{10}$/i, message:'手机格式错误', trigger:'blur'},
                    ],
                    email: [
                        {required: true, message: '邮箱不能为空', trigger: 'blur' },
                        { type: 'string', pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, message:'邮箱格式错误', trigger:'blur'},
                    ],
                    status: [
                        {required: true, message: '状态不能为空', trigger: 'change' },
                    ],
                    type: [
                        {required: true, message: '职位必须选择', trigger: 'change' },
                    ],
                    role_id: [
                        {type:'number',required: true, message: '角色必须选择', trigger: 'change' },
                    ],
                    all_section: [
                        {type: 'array',required: true, message: '部门必须选择', trigger: 'change' },
                    ],
                },
            }
        },
        components: {

        },
        watch:{
            showModel(val){
                if(val){
                    // this.getData()
                }
            }
        },
        created(){
            this.getSection()
            this.getRole()
        },
        methods: {
            getRole(){//获取所有商家角色
                this.axios.get(this.config.urlArray.usersRole,{}).then((result) => {
                    common.ajaxMsg(result.data);
                    this.roleList = result.data.data;
                }).catch((err) => {
                    common.msg('error','获取角色数据失败',()=>{})
                })
            },
            getSection(){//获取所有部门数据
                this.axios.get(this.config.urlArray.sectionsShow,{}).then((result) => {
                    common.ajaxMsg(result.data);
                    this.sectionData = result.data.data;

                }).catch((err) => {
                    common.msg('error','获取部门数据失败',()=>{})
                })
            },
            getData() {//获取数据
                let getData = {}
                this.axios.get(this.config.urlArray.empAccountList, getData).then((result) => {
                    common.ajaxMsg(result.data);

                }).catch((err) => {
                    common.msg('error','获取失败',()=>{})
                });
            },
            openOrClose(value) {
                if(value === true) {
                    if(this.type == 2){//编辑表单时，给表单赋值
                        this.formData.name = this.editFormData.name.toString();
                        this.formData.mobile = this.editFormData.mobile.toString();
                        this.formData.status = this.editFormData.status.toString();
                        this.formData.email = this.editFormData.email.toString();
                        this.formData.all_section = this.editFormData.all_section.split(',').map(Number)
                        this.formData.type = this.editFormData.type.toString();
                        this.formData.role_id = this.editFormData.role_id;
                    }
                    this.title = this.type == 1?'添加员工':'编辑员工'
                } else { //关闭弹框后要做的处理
                    this.resetForm();//重置表单
                }
            },
            subData(name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;

                        if (this.type == 2) {
                            this.formData.id = this.editFormData.id

                        }else if(this.formData.pwd == ''){
                            common.msg('error','密码必须填写',()=>{this.disabled = false;})
                            return
                        }

                        this.axios.post(this.config.urlArray.empStore, this.formData).then((result) => {
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                            },()=>{this.disabled = false; })

                        }).catch((err) => {
                            common.msg('error','提交失败',()=>{this.disabled = false;})
                        });

                    }
                })
            },
            setSelectVal(data,key){
                this.formData[key] = data.toString()
            },
            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
                if(this.type == 2){
                    delete this.formData.id
                }
            }
        }
    }
</script>
